import React from 'react';

import Div from '../../../div';

export default ({ isEnabled, noticeText, onChange }) =>
    <label style={{width:'100%'}}>
        <Div setup='r center center' h='40' wRel='100'>
                <Div>{ isEnabled ? noticeText : '(bez poznámky)' }</Div>
                <Div>
                    <input type='checkbox' checked={isEnabled} onClick={e => preventDefault(e, onChange)} value='dummy' readOnly={true}
                           style={{ width: '30px', height: '30px' }} />
                </Div>
        </Div>
    </label>

function preventDefault(e, onChange) {
    e.preventDefault();
    onChange();
}
